import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { Modal } from '../../atoms/Modal/Modal';
import { Typography } from '../../typo/Typography';
import { Button } from '../../Button/Button';
import { useAllLocales } from '../../../hooks/locale/useAllLocales';
import { useUserField } from '../../userFields/useUserField';
import { useRouter } from 'next/router';
import { useHasState } from '../hooks/useHasState';
import { useUser } from '../../../hooks/api/gql/user/queries/useUser';
import { useGetLocalizedKey } from '../helper/getTaxLocalizedKey';

interface IProfileTaxModal1Props {}

export const ProfileTaxModal1: React.FC<IProfileTaxModal1Props> = () => {
    const { push } = useRouter();

    const locales = useAllLocales();
    const { saveUserFields } = useUserField();
    const { hasState } = useHasState();
    const [show, setShow] = useState(false);

    const { getLocalizedKey, getLocalizedSuffix } = useGetLocalizedKey();

    const { data: userData } = useUser();

    const country = useMemo(() => {
        return userData?.fields.BL_Country_Origin ?? 'de-DE';
    }, [userData?.fields.BL_Country_Origin]);

    const LLSuffix: string | undefined = useMemo(() => {
        return getLocalizedSuffix(country);
    }, [country, getLocalizedSuffix]);

    const handleJumpToProfile = useCallback(() => {
        saveUserFields([
            {
                name: 'Invoice_Tax_State',
                value: '2',
            },
        ]);

        void push('/billing');
    }, [push, saveUserFields]);

    const handleHideModal = useCallback(() => {
        saveUserFields([
            {
                name: 'Invoice_Tax_State',
                value: '2',
            },
        ]);
    }, [saveUserFields]);

    useEffect(() => {
        if (hasState([1])) {
            setShow(true);
        }
    }, [hasState]);

    // console.log(getLocalizedKey('LL_PopUp_WaWi_ValdierungInfo_S1_H1_DE'));

    return (
        <Modal show={show} afterClose={() => {}} closeable={false}>
            {locales && (
                <div className="flex flex-col gap-6 p-4">
                    <Typography variant="h1-blue">
                        <span
                            dangerouslySetInnerHTML={{
                                __html: getLocalizedKey(
                                    'LL_PopUp_WaWi_ValdierungInfo_S1_H1_DE',
                                    LLSuffix
                                ),
                            }}
                        />
                    </Typography>
                    <Typography variant="h2-red">
                        <span
                            dangerouslySetInnerHTML={{
                                __html: getLocalizedKey(
                                    'LL_PopUp_WaWi_ValdierungInfo_S1_H2_DE',
                                    LLSuffix
                                ),
                            }}
                        />
                    </Typography>

                    <Typography variant="paragraph">
                        <span
                            dangerouslySetInnerHTML={{
                                __html: getLocalizedKey(
                                    'LL_PopUp_WaWi_ValdierungInfo_S1_C1_DE',
                                    LLSuffix
                                ),
                            }}
                        />
                    </Typography>

                    <Typography variant="h2-red">
                        <span
                            dangerouslySetInnerHTML={{
                                __html: getLocalizedKey(
                                    'LL_PopUp_WaWi_ValdierungInfo_S1_C2_DE',
                                    LLSuffix
                                ),
                            }}
                        />
                    </Typography>
                    <Typography variant="paragraph">
                        <span
                            dangerouslySetInnerHTML={{
                                __html: getLocalizedKey(
                                    'LL_PopUp_WaWi_ValdierungInfo_S1_C3_DE',
                                    LLSuffix
                                ),
                            }}
                        />
                    </Typography>
                    <div className="flex flex-col gap-4 mt-4">
                        <Button color="primary" onClick={handleJumpToProfile}>
                            {getLocalizedKey('LL_PopUp_WaWi_ValdierungInfo_S1_B1_DE', LLSuffix)}
                        </Button>

                        <Button color="default" onClick={handleHideModal}>
                            {getLocalizedKey('LL_PopUp_WaWi_ValdierungInfo_S1_B2_DE', LLSuffix)}
                        </Button>
                    </div>
                </div>
            )}
        </Modal>
    );
};
